module.exports = __webpack_public_path__ + "static/profile-ceri-taylor-496b7950ed5911639454f72a360fcf6b.jpg";